import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromLeaveRequest from './store/leave-request.reducer';
import { EffectsModule } from '@ngrx/effects';
import { LeaveRequestEffects } from './store/leave-request.effects';
import { LeaveRequestFeatureComponent } from './feature/leave-request.feature';
import { UIRouterModule } from '@uirouter/angular';
import { LeaveRequestRoute, LeaveRequestApprovalRoute } from './leave-request.route';
import { LeaveRequestComponent } from './presenters/leave-request.component';
import { SharedModule } from '../shared/shared.module';
import { FullCalendarModule } from '../shared/components/fullcalendar/fullcalendar.module';

@NgModule({
    declarations: [
        LeaveRequestFeatureComponent,
        LeaveRequestComponent,
    ],
    imports: [
        CommonModule,
        SharedModule,
        UIRouterModule,
        FullCalendarModule,
        StoreModule.forFeature(
            fromLeaveRequest.leaveRequestsFeatureKey,
            fromLeaveRequest.reducer
        ),
        EffectsModule.forFeature([LeaveRequestEffects]),
        UIRouterModule.forChild({
            states: [LeaveRequestRoute, LeaveRequestApprovalRoute]
        })
    ]
})
export class LeaveRequestModule {}
